import React, { Component } from "react";
import { connect } from "react-redux";
import { setModals } from '../../redux/actions';
import { Modal } from 'reactstrap';
import { getValueOfParameterFromURL, generateGUID } from '../../helpers/Utils';

class CustomModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalId: null,
      clickedBackButton: false,
      currentHash: window.location.hash.split("?")[0]?? ""
    }
  }

  componentDidMount () {
  }

  componentDidUpdate(prevProps) {
    const handle = () => {
      if (this.props.isOpen !== prevProps.isOpen) {
        if (this.props.isOpen) {
          window.location.hash = `${this.state.currentHash}?modalId=${this.state.modalId}`
        }
        else {
          const id = getValueOfParameterFromURL("modalId", window.location.href)
          if (id && this.state.clickedBackButton === false) {
            window.history.go(-1);
          }
        }
      }
    }
    if (this.props.isOpen && this.state.modalId === null) {
      const id = generateGUID()
      this.setState({modalId: id}, () => {
        let modals = this.props.modals
        modals.push(this.state.modalId)
        this.props.setModals(modals)
        window.addEventListener('popstate', this.handleUrlChange)
        handle()
      })
    } else handle()
  }

  componentWillUnmount () {
    window.removeEventListener('popstate', this.handleUrlChange)
  }

  handleUrlChange = () => {
    let modals = this.props.modals
    const id = getValueOfParameterFromURL("modalId", window.location.href)
    const isLast = this.props.modals[this.props.modals.length - 1] === this.state.modalId
    if (this.props.isOpen && this.state.modalId !== id && (isLast || id === null || this.props.modals.indexOf(id) === -1)) {
      this.setState({clickedBackButton: true}, () => {
        modals.pop(this.state.modalId)
        this.props.setModals(modals)
        this.props.toggle()
      })
    } else this.setState({clickedBackButton: false})
  }

  render() {
    const { setModals, modals, children, ...rest } = this.props
    return (
      <Modal {...rest}>
        {children}
      </Modal>
    )
  }
}

const mapStateToProps = ({ utils }) => {
  const { modals } = utils
  return { modals }
}

export default connect(mapStateToProps, { setModals })(CustomModal)